import { render, staticRenderFns } from "./subMapbi.vue?vue&type=template&id=5cdb04b0&scoped=true"
import script from "./subMapbi.vue?vue&type=script&lang=js"
export * from "./subMapbi.vue?vue&type=script&lang=js"
import style0 from "./skin.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./common.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./subMapbi.vue?vue&type=style&index=2&id=5cdb04b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdb04b0",
  null
  
)

export default component.exports